var React = require('react');

function Lightning (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"tigerface-icons"),React.createElement("polygon",{"points":"8.29 1.26 17.28 1.26 13.99 7.33 18.14 7.33 6.95 22.74 8.76 12 5.86 12 8.29 1.26","key":1})]);
}

Lightning.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Lightning;

Lightning.default = Lightning;
